<div class="page-name-title" *ngIf="pageData?.pageName && !spinnerActive">
  <span *ngIf="pageData?.pageName == 'Landing'">
    <mat-icon>home</mat-icon> {{pageData.pageName}}
  </span>
  <span *ngIf="pageData?.pageName != 'Landing'" class="mdi mdi-window-maximize">
    {{pageData.pageName | titlecase}}
  </span>
</div>


<div class="mobile-canvas-container" (click)="navigateToPages()">
  <!-- mobile header static icons  -->
  <div class="mobile-header-signal-content">
    <svg viewBox="0 0 336 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="336" height="16" fill="none" />
      <g id="Android-status-bar_dark">
        <text id="12:30 PM" fill="#170E2B" xml:space="preserve" style="white-space: pre" font-family="Roboto"
          font-size="14" font-weight="500" letter-spacing="0.001em">
          <tspan class="time" x="0" y="12.7852">{{currentTime}}</tspan>
        </text>
        <g id="icons">
          <path id="Cellular" fill-rule="evenodd" clip-rule="evenodd"
            d="M282.941 2H281.882C281.298 2 280.824 2.50368 280.824 3.125V12.875C280.824 13.4963 281.298 14 281.882 14H282.941C283.526 14 284 13.4963 284 12.875V3.125C284 2.50368 283.526 2 282.941 2ZM276.941 4.625H278C278.585 4.625 279.059 5.12868 279.059 5.75V12.875C279.059 13.4963 278.585 14 278 14H276.941C276.356 14 275.882 13.4963 275.882 12.875V5.75C275.882 5.12868 276.356 4.625 276.941 4.625ZM273.059 7.25H272C271.415 7.25 270.941 7.75368 270.941 8.375V12.875C270.941 13.4963 271.415 14 272 14H273.059C273.644 14 274.118 13.4963 274.118 12.875V8.375C274.118 7.75368 273.644 7.25 273.059 7.25ZM268.118 9.5H267.059C266.474 9.5 266 10.0037 266 10.625V12.875C266 13.4963 266.474 14 267.059 14H268.118C268.702 14 269.176 13.4963 269.176 12.875V10.625C269.176 10.0037 268.702 9.5 268.118 9.5Z"
            fill="#170E2B" />
          <path id="Wifi" fill-rule="evenodd" clip-rule="evenodd"
            d="M298 4.49216C300.322 4.49226 302.555 5.42402 304.237 7.09485C304.364 7.22384 304.566 7.22222 304.691 7.0912L305.902 5.81448C305.965 5.74803 306.001 5.65802 306 5.56436C305.999 5.47071 305.963 5.38114 305.899 5.31546C301.483 0.894846 294.517 0.894846 290.101 5.31546C290.037 5.38109 290.001 5.47063 290 5.56429C289.999 5.65794 290.035 5.74798 290.098 5.81448L291.309 7.0912C291.434 7.22241 291.637 7.22404 291.763 7.09485C293.446 5.42391 295.679 4.49215 298 4.49216ZM298 8.64588C299.276 8.6458 300.506 9.14102 301.451 10.0353C301.579 10.1622 301.781 10.1595 301.905 10.0291L303.115 8.7524C303.179 8.68543 303.214 8.59458 303.213 8.50018C303.212 8.40578 303.175 8.3157 303.11 8.2501C300.231 5.45256 295.772 5.45256 292.893 8.2501C292.828 8.3157 292.791 8.40582 292.79 8.50026C292.789 8.59469 292.825 8.68553 292.889 8.7524L294.098 10.0291C294.223 10.1595 294.424 10.1622 294.552 10.0353C295.497 9.14161 296.726 8.64644 298 8.64588ZM300.424 11.4406C300.425 11.5353 300.39 11.6265 300.325 11.6929L298.233 13.8987C298.171 13.9635 298.088 14 298 14C297.913 14 297.83 13.9635 297.768 13.8987L295.675 11.6929C295.611 11.6265 295.575 11.5352 295.577 11.4405C295.579 11.3459 295.618 11.2562 295.685 11.1928C297.022 10.0121 298.979 10.0121 300.315 11.1928C300.383 11.2563 300.422 11.3459 300.424 11.4406Z"
            fill="#170E2B" />
          <g id="Battery">
            <path id="Union" opacity="0.4" fill-rule="evenodd" clip-rule="evenodd"
              d="M314.667 3H331.037C331.957 3 332.703 3.74619 332.703 4.66667V11.3333C332.703 12.2538 331.957 13 331.037 13H314.667C313.746 13 313 12.2538 313 11.3333V4.66667C313 3.74619 313.746 3 314.667 3ZM312 4.66667C312 3.19391 313.194 2 314.667 2H331.037C332.509 2 333.703 3.19391 333.703 4.66667V11.3333C333.703 12.8061 332.509 14 331.037 14H314.667C313.194 14 312 12.8061 312 11.3333V4.66667ZM336 8C336 8.9245 335.484 9.75894 334.69 10.1176V5.88235C335.484 6.24106 336 7.07551 336 8Z"
              fill="#170E2B" />
            <rect id="Capacity" x="313.973" y="4.11765" width="17.7573" height="7.76471" rx="1.33333" fill="#170E2B" />
          </g>
        </g>
      </g>
    </svg>

  </div>
  <ng-container *ngIf="pageData">

    <div class="mobile-canvas"  [ngStyle]="pageData.pageConfig?.style"  [class.screenblur]="spinnerActive">
      <div class="mobile-canvas-inner" >
        <div cdkDropList *ngIf=" pageSectionList1 && pageSectionList1?.length == 0 " [cdkDropListData]="[]" class="flex-grow-1" style="min-height: 80vh;" (cdkDropListDropped)="drop($event)">
          <div *ngFor="let item of []; trackBy: trackByFn" cdkDrag></div>
        </div>
               <!-- navbar  -->
        <ng-container *ngIf="navBarConfig as form">

        <div class="mb-nav-container navbar" *ngIf="form?.formConfig?.enable" [ngStyle]="form.formConfig?.style" (mouseenter)="form.showDeleteButton = true" (mouseleave)="form.showDeleteButton = false">
          <ng-container *ngIf="form.widgets">
              <mat-toolbar [ngStyle]="form.formConfig?.style" class="navbar">
                <div class="toolbar-start">
                  <button mat-icon-button [ngStyle]="form.widgets[0].widgetConfig.style"
                  (click)="onClick(form.widgets[0].widgetId, 0, 0, form.widgets[0])">
                  <mat-icon>{{ form.widgets[0]?.widgetConfig?.image || 'arrow_back' }}</mat-icon>
                </button>
                </div>
                <div class="toolbar-title" (click)="onClick(form.widgets[1]?.widgetId, 0, 1, form.widgets[1])" [ngStyle]="form.widgets[1].widgetConfig.style">{{ form.widgets[1].widgetLabel }}</div>
                <div class="toolbar-end" *ngIf="form.widgets[2]?.widgetConfig?.enabled ?? false">
                  <button mat-icon-button [ngStyle]="form.widgets[2]?.widgetConfig?.style"
                  (click)="onClick(form.widgets[2]?.widgetId, 0, 2, form.widgets[2])">
                  <mat-icon>{{ form.widgets[2]?.widgetConfig?.image || 'arrow_back' }}</mat-icon>
                </button>
                </div>                  
              </mat-toolbar>
          </ng-container>
        </div>

      </ng-container>
      <!-- when empty  -->
        <ng-container *ngFor="let form of pageSectionList1; let i = index" >
   
          <ng-container *ngIf="((pageSectionList1 && pageSectionList1?.length === 1 && (pageSectionList1[0].formConfig?.formType === formTypes.navbar|| pageSectionList1[0].formConfig?.formType === formTypes.menuPanel )) || 
                  (pageSectionList1 && pageSectionList1?.length === 2 && (pageSectionList1[1].formConfig?.formType === formTypes.navbar || pageSectionList1[1].formConfig?.formType === formTypes.menuPanel)))">
            <div *ngIf="form.formConfig?.formType === formTypes.navbar" cdkDropList [cdkDropListData]="[]" class="flex-grow-1" style="min-height: 80vh;"  (cdkDropListDropped)="drop($event)">
              <div *ngFor="let item of []; trackBy: trackByFn" cdkDrag></div>
            </div>
          </ng-container>
        </ng-container>

          <!-- Main section -->
          <ng-container *ngIf="widgetsForm as form">
            <div class="mb-section-container " [class.selected-section]="form.open" [ngStyle]="form.formConfig?.style" cdkDropList [cdkDropListData]="widgetsForm.widgets"  (cdkDropListDropped)="drop($event)"
              (mouseenter)="form.showDeleteButton = true" (mouseleave)="form.showDeleteButton = false" [class.imageCenter]="pageData.pageType === 'SplashScreenPage'">
              <div class="mb-widget-action" *ngIf="pageData.pageType !== 'PreviewPage'">
                @if([appPermissions.editPage,permissionsActions.edit] | builderPermissions){
                  <button mat-mini-fab matTooltip="Delete Section" matTooltipPosition="above"  (click)="deleteSection(widgetsFormIndex,form,pageData)">
                    <mat-icon>delete</mat-icon>
                  </button>
                  <button mat-mini-fab matTooltip="Edit Section" matTooltipPosition="above"  (click)="onSectionClick(widgetsFormIndex,form)">
                    <mat-icon>edit</mat-icon>
                  </button>
                }
              </div>
                @for (widget of form.widgets; track widget; let j = $index){

                <div 
                  class="mb-item-widget" cdkDragBoundary (mouseenter)="setHoveredWidget(widgetsFormIndex, j)"
                  (mouseleave)="clearHoveredWidget()"  cdkDrag [cdkDragData]="widget" class="mb-component-container" [cdkDragDisabled]="defaultPages.includes(pageData.pageType ?? '')"
                  *ngIf="(pageData?.pageType?.trim() === pageTypes.dataListView && widget?.widgetConfig?.enable) || pageData.pageType?.trim() !== pageTypes.dataListView">

                    <div class=" example-custom-placeholder" *cdkDragPlaceholder></div>
                    <div class="mb-widget-action" *ngIf="pageData.pageType !== 'PreviewPage'">
                      @if([appPermissions.editPage,permissionsActions.edit] | builderPermissions){
                        <button *ngIf="!defaultPages.includes(pageData.pageType ?? '')" mat-mini-fab matTooltip="Delete Widget" matTooltipPosition="above"
                          (click)="deleteWidget(pageData, widgetsFormIndex,form, widget)">
                          <mat-icon>delete</mat-icon>
                        </button>
                      }
                    </div>

                    <lib-widget-filter  [widget]="widget" [sectionIndex]="widgetsFormIndex" [widgetIndex]="j" [editPagePermission]="[appPermissions.editPage,permissionsActions.edit] | builderPermissions"
                      [page]="pageData"></lib-widget-filter>
                  </div>
                }
            </div>
          </ng-container>
        
          <!-- menu panel -->
          <ng-container *ngIf="menuBarConfig as form">

            <div class="mb-sidebar-continer" (click)="onClick(pageSectionList1?.[0]?.widgets?.[0]?.widgetId, menuPanelIndex, 0, pageSectionList1?.[0]?.widgets?.[0])" *ngIf="isShowMenu">
             <div class="md-sidebar-panel" [ngStyle]="form.formConfig?.style">
              <div class="mb-toolbar" [ngStyle]="{'background-color': applicationTheme.primaryColor, 'color': applicationTheme.defaultTextColor}">
                <mat-toolbar [ngStyle]="{'background-color': applicationTheme.primaryColor, 'color': applicationTheme.secondaryColor}">
                  <span>Hello, {{userInfo?.firstName | titlecase}}</span>
                </mat-toolbar>
              </div>

              <div class="mb-menu-content"><ng-container *ngIf="form.widgets">
                <ng-container *ngFor="let widget of form.widgets; let j = index">
                  <div class="mb-menu-item"  *ngIf="widget.widgetConfig.enable" [style.color]="widget.widgetConfig?.style?.color">
                      <span>{{widget.widgetLabel}}</span>
                  </div>
                </ng-container>
              </ng-container>
              </div>
             </div>

            </div>
          </ng-container>
      </div>
    </div>
    <div *ngIf="spinnerActive" [class.spinnerCenter]="spinnerActive">
      <mat-spinner diameter="40"></mat-spinner>  
    </div>
  </ng-container>
</div>
